import Model from './Model';

export default class WorkExperience extends Model {
    job_working_area;
    function_title;
    company_name;
    city;
    start_date;
    end_date;
    current_position;

    toJson() {
        const dtoIds = {
            job_working_area_id: this.job_working_area.id
        };

        this.current_position = this.current_position ? true : false;

        return { ...this, ...dtoIds };
    }
}




// WEBPACK FOOTER //
// ./src/models/WorkExperience.js